import { applyToAllStates } from '../../../theme/utils/form.utils';
var iconStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '&[data-view-mode="true"]': applyToAllStates({
    display: 'none',
    cursor: 'auto',
    userSelect: 'all',
    pointerEvents: 'none'
  }),
  _readOnly: applyToAllStates({
    cursor: 'auto',
    userSelect: 'all',
    pointerEvents: 'none',
    color: 'neutral.light'
  }),
  _disabled: applyToAllStates({
    pointerEvents: 'none',
    color: 'neutral.light',
    cursor: 'not-allowed'
  })
};
export var dateFieldTheme = {
  baseStyle: {
    trigger: {
      cursor: 'pointer',
      caretColor: 'transparent'
    },
    calendarIcon: iconStyle,
    closeIcon: iconStyle,
    popover: {
      width: 'max-content',
      border: 'none',
      zIndex: 'popover'
    },
    dateInputCalendar: {
      position: 'relative',
      padding: 'm',
      paddingTop: 'none',
      marginTop: 'm'
    }
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=DateField.theme.js.map